import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareFieldsRoute: InvariantJiraRoute = {
	name: 'classic-project-settings-software-fields',
	path: '/jira/software/c/projects/:projectKey/settings/fields',
	exact: true,
};
